import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["opportunities", "responsivnes"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from 'react';
import Carousel from 'react-multi-carousel';
import { redirectToRoute } from '@app/helpers';
import { useUser } from '@app/helpers/hooks';
import { OPP_STATUS_ENUM } from '@app/constants';
import OpportunityCard from '../../opportunities/OpportunityCard';
import { CardContainer, SliderContainer } from './style';
import { jsx as _jsx } from "react/jsx-runtime";
var responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 4,
    slidesToSlide: 1,
    removeArrowOnDeviceType: true // optional, default to 1.
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 600
    },
    items: 3,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: {
      max: 600,
      min: 0
    },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};
var handleViewOpportunity = function handleViewOpportunity(slug) {
  return function () {
    redirectToRoute({}, 'view_opportunity', {
      params: {
        slug: slug
      }
    });
  };
};

// eslint-disable-next-line react/prop-types
var FeaturedSlider = function FeaturedSlider(_ref) {
  var opportunities = _ref.opportunities,
    responsivnes = _ref.responsivnes,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useUser = useUser(),
    user = _useUser.user;
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  useEffect(function () {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    }
  }, []);
  return /*#__PURE__*/_jsx(SliderContainer, {
    children: /*#__PURE__*/_jsx(Carousel, _objectSpread(_objectSpread({
      swipeable: isMobile,
      draggable: false,
      showDots: false,
      responsive: responsivnes,
      ssr: true // means to render carousel on server-side.
      ,
      infinite: true
      //   autoPlay={this.props.deviceType !== "mobile" ? true : false}
      ,
      autoPlaySpeed: 2000
      // autoPlay
      ,
      keyBoardControl: true
      //   customTransition="all .5"
      ,
      transitionDuration: 500,
      containerClass: "carousel-container",
      removeArrowOnDeviceType: ['tablet', 'mobile']
      //   deviceType={this.props.deviceType}
      ,
      dotListClass: "custom-dot-list-style",
      itemClass: "carousel-item-padding-40-px"
    }, props), {}, {
      children: opportunities.filter(function (opportunity) {
        return !opportunity.is_draft && opportunity.opp_status !== OPP_STATUS_ENUM.DRAFT && !opportunity.is_private;
      }).map(function (opportunity) {
        return (
          /*#__PURE__*/
          // <Grid key={opportunity.id} item xs={12} sm={12} md={10} lg={4}>
          _jsx(CardContainer, {
            children: /*#__PURE__*/_jsx(OpportunityCard, _objectSpread(_objectSpread({
              userInfo: user
            }, opportunity), {}, {
              onClick: handleViewOpportunity(opportunity.slug)
            }))
          }, opportunity.slug)
        );
      })
    }))
  });
};
FeaturedSlider.defaultProps = {
  responsivnes: responsive
};
export default FeaturedSlider;